<mat-button-toggle-group class="active-inactive-toggle" fxFlex="100">
  <mat-button-toggle fxFlex="50" [disabled]="disabled" [checked]="!inactive" (click)="setInactive(false)">
    {{ activeLabel }}
  </mat-button-toggle>
  <mat-button-toggle fxFlex="50" [disabled]="disabled" [checked]="inactive" (click)="setInactive(true)">
    {{ inactiveLabel }}
  </mat-button-toggle>
</mat-button-toggle-group>
